import * as C from '../common/constants';
import Header from './Header';
import Loader from './Loader';
import Scene from './Scene';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import Adjustments from './Adjustments';
import MenuWrapper from './MenuWrapper';
import FPSStats from 'react-fps-stats';
import { useSelector, useDispatch } from 'react-redux';
import { useRef, useEffect } from 'react';
import { fetchData } from '../common/app/actions';
import Warning from './Warning';

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      boxStyle: {
        width: '100%',
        height: '100%',
        // background: COLORS.appBackground,
      },
      headerStyle: {
        position: 'absolute',
        width: '100%',
        left: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        pointerEvents: 'none',
        boxSizing: 'border-box',
        padding: '14px 20px',
      },
      logoStyle: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '& > svg': {
          width: '280px',
          height: '36px',
          fill: COLORS.white,
        },
        '& > span': {
          color: COLORS.lightGrey,
          fontSize: '12px',
        },
      },
      '@media (max-width: 600px)': {
        logoStyle: {
          '& > svg': {
            width: '220px',
            height: '32px',
          },
          '& > span': {
            fontSize: '10px',
          },
        },
      },
      '@media (max-width: 420px)': {
        logoStyle: {
          '& > svg': {
            width: '180px',
            height: '24px',
          },
          '& > span': {
            fontSize: '8px',
          },
        },
      },
      '@media only screen and (max-height: 600px)': {
        logoStyle: {
          padding: '0 20px',
          '& > svg': {
            width: '250px',
            height: '40px',
            paddingBottom: '4px',
          },
          '& > span': {
            fontSize: '12px',
          },
        },
      },
    })
);

const isDev = process.env.NODE_ENV !== C.PRODUCTION;

const Home = (): JSX.Element => {
  const classes = useStyles();
  const dispatch: any = useDispatch();
  const appData = useSelector((state: any) => state.app[C.APP_DATA]);

  const ref = useRef(null);

  useEffect(() => {
    if (!appData) {
      dispatch(fetchData(C.APP_DATA));
    }
  }, [appData]);

  // if (!appData) {
  //   return <div className={classes.boxStyle}></div>;
  // }

  return (
    <div className={classes.boxStyle} ref={ref}>
      <Scene />
      <div className={classes.headerStyle}>
        <div className={classes.logoStyle}>
          <Header />
        </div>
      </div>
      <Loader />
      <Adjustments />
      <MenuWrapper mainRef={ref} />
      {isDev && <FPSStats />}
      {/* <Warning /> */}
    </div>
  );
};

export default Home;
